<script>
  import SubscriptionSelectionCard from './SubscriptionSelectionCard.svelte';
  import getTranslation from '../../utilities/getTranslation';

  import { hasPriceOffer } from './helper';

  export let data, cards, componentInformationKeys, isMyAccountPage, sthp, urlStyleLocale;

  const {
    currentSubscription,
    isCustomerInactive,
    featuredProductMetadataId,
    countryIso,
    language,
    upcomingSubscription,
    welcomeCampaigns,
  } = data;

  const subscriptionCards = data.firstRow.productGroups.length;

  const hasOfferSpan = data.firstRow.productGroups
    .map((group) => hasPriceOffer(group))
    .some(Boolean);

  const hasOfferTerms = data.firstRow.productGroups
    .map((group) => {
      return getTranslation(group.informationKeys, 'pricing.offer.duration', '') !== '';
    })
    .some(Boolean);
</script>

<style lang="scss">
  @use './index' as *;

  .subscription-area {
    display: block;
    justify-content: center;

    &-one-or-two-cards {
      @include mq($from: tabletlandscape, $until: desktop) {
        grid-template-columns: repeat(auto-fit, minmax(25.1rem, 34.1rem));
        grid-template-rows: repeat(9, auto);
        grid-auto-flow: column;
        align-items: stretch;
      }
    }

    @include mq($from: 300px) {
      display: grid;
      grid-gap: 0 spacing(4);
    }

    @include mq($from: tabletlandscape) {
      grid-template-rows: repeat(9, auto);
      grid-template-columns: repeat(auto-fit, minmax(25.1rem, 34.1rem));
      grid-auto-flow: column;
    }

    &-four-cards {
      grid-auto-flow: row;
      grid-template-columns: auto;
      @include mq($from: desktop) {
        grid-template-columns: repeat(auto-fit, minmax(25.1rem, 34.1rem));
        grid-auto-flow: column;
      }
    }

    &-vertical {
      grid-auto-flow: row;
      grid-template-columns: unset;
    }
  }
</style>

<div
  class="subscription-area"
  class:subscription-area-vertical={isMyAccountPage}
  class:subscription-area-one-or-two-cards={subscriptionCards < 3}
  class:subscription-area-four-cards={subscriptionCards >= 4}
>
  {#each data.firstRow.productGroups as subscription, i}
    <div bind:this={cards[i].wrapper} />
    <SubscriptionSelectionCard
      {sthp}
      subscription={{
        ...subscription,
        currentSubscription,
        isCustomerInactive,
        featuredProductMetadataId,
        countryIso,
        language,
        upcomingSubscription,
        welcomeCampaigns,
      }}
      {componentInformationKeys}
      {hasOfferSpan}
      {hasOfferTerms}
      {urlStyleLocale}
    />
  {/each}
</div>
